<template>
    <div>
        <b-card :header="uLang('app.create')" header-tag="h4" class="bg-default-card">
            <milestone-form v-if="project && trajectory" :project="project" :trajectory="trajectory" :overrideEndpoint="overrideEndpoint"/>
        </b-card>
    </div>
</template>

<script>
    import MilestoneForm from '~/components/forms/admin/projects/milestone/form'

    export default {
        name: 'create',

        props: {
            projectId: {
                required: true,
            },
            trajectoryId: {
                required: true,
            },
        },

        components: {
            'milestone-form': MilestoneForm,
        },

        data() {
            return {
                project: undefined,
                trajectory: undefined,
            };
        },

        created() {
            this.retrieveProject();
            this.retrieveTrajectory();
        },

        methods: {
            async retrieveProject() {
                const {data} = await window.axios.get(route('trajectory-projects.show', { trajectory_project: this.projectId }));
                this.project = data;
            },

            async retrieveTrajectory() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId }));
                this.trajectory = data;
            },
        },

        computed: {
            overrideEndpoint() {
                return route('trajectory-projects.trajectories.milestones.store', { trajectory_project: this.projectId, trajectory: this.trajectoryId })
            }
        },
    }
</script>

<style lang="css" scoped>
</style>